import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { useRouteBaseStateContext } from "../../../Context/RouteBaseStateContext";
import { payPayment } from "../../../redux/common/action";
import { useDispatch, useSelector } from "react-redux";
import { urtoast } from "../../Layouts/CustomPopup/eventEmitter";

export default function PaymentSuccessful() {
  const { transaction_id } = useParams();
  const { search } = useLocation();
  const [paymentApiResponse, setPaymentApiResponse] = useState("")
  const [paymentApiResponseMessage, setPaymentApiResponseMessage] = useState("")
  const params = new URLSearchParams(search);
  const checkoutId = params.get("id");
  const resourcePath = params.get("resourcePath");
  const walletQuery = params.get("wallet");

  console.log("transaction_id:", transaction_id);
  console.log("checkoutId:", checkoutId);
  console.log("resourcePath:", resourcePath);
  const { urlstate, resetAllFields } = useRouteBaseStateContext();
  const laung = localStorage.getItem("laung");
  const path = "Assets/scss/FirstTimeUsers.module.scss";
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;

  useEffect(() => {
    LoadCSSforfirstTime(path);
    resetAllFields();
  }, [path]);

  const dispatch = useDispatch();

  const calledRef = useRef(false);

  useEffect(() => {
    if (transaction_id && !calledRef.current) {
      calledRef.current = true;
      apiCallforPaymentResponse();
    }
  }, [transaction_id]);


  const apiCallforPaymentResponse = () => {
    const data = {
      "type": "12",
      transaction_id: transaction_id,
      wallet: walletQuery ? parseInt(walletQuery) : 0,
    };

    dispatch(payPayment(data, navigate)).then((res) => {
      // console.log(res, 'resresresresresresresresres')
      setPaymentApiResponse(res?.data?.response?.result)
      setPaymentApiResponseMessage(res?.data?.response)
      if (res?.data?.status) {
        urtoast(res?.data?.response?.message, 1);
      }
      else {
        urtoast(res?.data?.response?.message, 2);
      }
    })
  };


  // console.log(paymentApiResponse, ';paymentApiResponse');
  console.log(paymentApiResponse, ';paymentApiResponse');
  console.log(paymentApiResponseMessage, ';paymentApiResponseMessage');

  const navigateByTransactionType = (result) => {
    const lan = localStorage.getItem("laung") ?? "en";

    if (!result) {
      navigate(`/${lan}/dashboard`);
      return;
    }

    const { type, master_id, master_id2, post_status } = result;

    switch (type) {
      case 1: // Project
      case 4:
        if (post_status == 2 || post_status == 22) {
          // Active project detail page
          navigate(`/${lan}/dashboard/myorders/project/active/${master_id}`);
        } else {
          // Recent / completed project
          navigate(`/${lan}/dashboard/myorders/project/recent/${master_id}`);
        }
        break;

      case 2: // Contest
        navigate(`/${lan}/dashboard/myorders/contest/active/${master_id}`);
        break;

      case 3: // Job
        if (post_status == 2 || post_status == 22) {
          navigate(`/${lan}/dashboard/myorders/job/active/${master_id}`);
        } else {
          navigate(`/${lan}/dashboard/myorders/job/recent/${master_id}`);
        }
        break;


      case 5:
        navigate(`/${lan}/auctiondetails/${master_id}`);
        break;

      case 6:
        navigate(`/${lan}/dashboard/receivedorders/actionorderdetails/${master_id}`);
        break;

      case 7:
        navigate(`/${lan}/dashboard/receivedorders/rentalproductsdetails/${master_id}`);
        break;

      case 8:
        navigate(`/${lan}/dashboard/receivedorders/productforsaledetails/${master_id}`);
        break;

      case 9:
        navigate(`/${lan}/packageddetails/${master_id}`);
        break;
      case 10:
        navigate(`/${lan}/dashboard/receivedorders/project/active/${master_id}`);
        break;

      case 12:
        navigate(`/${lan}/dashboard/membership`);
        break;

      default:
        navigate(`/${lan}/dashboard`);
    }
  };

  // useEffect(() => {
  //   if (paymentApiResponse?.status) {
  //     navigateByTransactionType(paymentApiResponse);
  //   }
  // }, [paymentApiResponse]);

  console.log(paymentApiResponse?.status, 'paymentApiResponse?.status');
  // {
  //     "message": "Updated Successfully",
  //     "result": {
  //         "error": "",
  //         "status": 1,
  //         "transaction_id": "271T1767599280",
  //         "amount": 44,
  //         "type": 1,
  //         "master_id": 1387
  //     }
  // }

  // 1-milestone,2-contest,3-jobreques,4-project,
  // 5-auctiondeposit,6-auctionbid,7-rentalrequest,8-salerequest,
  // 9-bxpRequest,10-bxpRequestMilestone,12membership

  // status==0 Pending
  // status==1 Success
  // status==2 Failed

  const Loader = ({ type }) => (
    <div className="text-center py-5">
      <div className="spinner-border text-primary" role="status" />
      {type == 1 ? <p className="mt-3">Loading...</p> : <p className="mt-3">Payment is being processed...</p>}
    </div>
  );

  return (
    <>
      <div className="col-md-8 mx-auto signuppage">
        {!paymentApiResponse ? <Loader type={1} /> :
          <>
            {paymentApiResponse?.status == 0 && (
              <Loader />
            )}

            {paymentApiResponse?.status == 2 && (
              <>
                <div className="col-md-6 mx-auto text-center">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/x-circle.svg`}
                    alt="failed"
                    className="btn close-button"
                  />
                  <h1>Payment Failed</h1>
                  <p>Please try again or use a different payment method.</p>
                </div>
                <div className="visit">
                  <button
                    onClick={() => navigateByTransactionType(paymentApiResponse)}
                    className="btn"
                  >
                    Retry Payment
                  </button>
                </div>
              </>
            )}

            {paymentApiResponse?.status == 1 && (
              <>
                <div className="col-md-6 mx-auto text-center">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/tick-back.svg`}
                    alt="success"
                  />
                  <h1>{paymentApiResponseMessage?.message || "Success! Your payment has been completed."}</h1>
                </div>
                <div className="visit">
                  <button
                    onClick={() => navigateByTransactionType(paymentApiResponse)}
                    className="btn"
                  >
                    Okay
                  </button>
                </div>
              </>
            )}
            {paymentApiResponse &&
              ![0, 1, 2].includes(paymentApiResponse.status) && (
                <>
                  <div className="col-md-6 mx-auto text-center">
                    <h1>Something went wrong.</h1>
                  </div>
                  <div className="visit">
                    <button
                      onClick={() => navigateByTransactionType(paymentApiResponse)}
                      className="btn"
                    >
                      Okay
                    </button>
                  </div>
                </>
              )}
          </>}
      </div>
    </>
  );

}
